<template>
  <EventHorizontalProductShowcase
    v-if="similarOnlineEvents.length || pending"
    :products="similarOnlineEvents"
    :pending="pending"
    :title="t('product.similarOnlineEvents')"
    :gtm-item-list-id="GtmItemListId.EventPageSimilarOnlineClasses"
    :algolia-insights-label="algoliaInsightsLabel"
    data-test-id="online-events"
    :loader-products-count="similarOnlineEvents.length || 6"
  />
</template>

<script setup lang="ts">
import { GtmItemListId } from '~/composables/useKftGtm/types'
import type { EventDescription } from '~/composables/types/event'
import { useSimilarOnlineEvents } from '~/composables/search/useSimilarOnlineEvents'

const { algoliaInsightsLabel = 'Similar Online Events - Event Page' } =
  defineProps<{
    algoliaInsightsLabel?: string
  }>()

const eventData = inject<EventDescription>('eventData')
const { t } = useI18n()
const permalink = eventGetters.getPermalink(eventData)
// Engine-aware (KFT-4115): KFT API on algolia, Typesense on typesense, and
// it follows an A/B force after hydration.
const { data: similarOnlineEvents, pending } = useSimilarOnlineEvents(
  permalink,
  eventGetters.getMainCategorySlug(eventData)
)
</script>
